// extracted by mini-css-extract-plugin
export default {"linkBox":"vtNQK8c5OXcaHTS6j6mY","link":"Nepf1Dd8WmIQKcdJvAuv","videoPreview":"nifpSnlUd1vgkQfXIAcm","dragHandle":"VenQnonq0oIUsTM3j1jQ"};